import { function_ABM_CON_Monedas_Leer } from '../../ABM/CONT/ABM_CON_Monedas';
import { RespuestaLecturaError } from '../../Mensajes';
import { llamadaAPI_GET, llamadaAPI_GETBinario, llamadaAPI_POST, llamadaAPI_PUT } from '../../SQL';
import { TratamientoDeParametroParaURI } from '../../Varios';

export const function_VEN_Pedidos_Cabecera_Listar = async (FechaDesde, FechaHasta) => {
    const NombreFuncion = "function_VEN_Pedidos_Cabecera_Listar"

    try {
        const resulData = await llamadaAPI_GET("VEN_Pedidos_Cabecera/Listar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Pedidos_Cabecera_ListarComisiones = async (FechaDesde, FechaHasta) => {
    const NombreFuncion = "function_VEN_Pedidos_Cabecera_ListarComisiones"

    try {
        const resulData = await llamadaAPI_GET("VEN_Pedidos_Cabecera/ListarComisiones/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Pedidos_Cabecera_ListarSoloClientesPropios = async (FechaDesde, FechaHasta) => {
    const NombreFuncion = "function_VEN_Pedidos_Cabecera_ListarSoloClientesPropios"

    try {
        const resulData = await llamadaAPI_GET("VEN_Pedidos_Cabecera/ListarSoloClientesPropios/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            localStorage.getItem("IdPersona") + "/" +
            FechaDesde + "/" +
            FechaHasta);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Pedidos_Cabecera_FaltanteDeFacturacion = async (FechaDesde, FechaHasta) => {
    const NombreFuncion = "function_VEN_Pedidos_Cabecera_FaltanteDeFacturacion"

    try {
        const resulData = await llamadaAPI_GET("VEN_Pedidos_Cabecera/ListarFaltanteDeFacturacion/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Pedidos_Cabecera_ListarParaFacturarRemitir = async () => {
    const NombreFuncion = "function_VEN_Pedidos_Cabecera_ListarParaFacturarRemitir"

    try {
        const resulData = await llamadaAPI_GET("VEN_Pedidos_Cabecera/ListarParaFacturarRemitir/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta"));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Pedidos_Cabecera_Leer = async (IdPedido) => {
    const NombreFuncion = "function_VEN_Pedidos_Cabecera_Leer"

    try {
        const resulData = await llamadaAPI_GET("VEN_Pedidos_Cabecera/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdPedido);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Pedidos_Cabecera_ComparacionADiaAnterior = async (FechaConsulta) => {
    const NombreFuncion = "function_VEN_Pedidos_Cabecera_ComparacionADiaAnterior"

    try {
        const resulData = await llamadaAPI_GET("VEN_Pedidos_Cabecera/ComparacionADiaAnterior/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaConsulta);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

//HACER
export const function_VEN_Pedidos_Cabecera_LeerParaDocVenta = async (IdPedido) => {
    const NombreFuncion = "function_VEN_Pedidos_Cabecera_LeerParaDocVenta"

    try {
        const resulData = await llamadaAPI_GET("VEN_Pedidos_Cabecera/Leer/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdPedido);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Pedidos_Cabecera_Insertar = async (Pedido) => {
    const NombreFuncion = "function_VEN_Pedidos_Cabecera_Insertar";

    try {
        const pedidoResult = await llamadaAPI_POST("VEN_Pedidos_Cabecera/InsertarCompleto", Pedido);
        return pedidoResult;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_VEN_Pedidos_Cabecera_Modificar = async (Pedido) => {
    const NombreFuncion = "function_VEN_Pedidos_Cabecera_Modificar";

    try {
        await llamadaAPI_PUT("VEN_Pedidos_Cabecera/ModificarCompleto", Pedido);
        return true;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_VEN_Pedidos_Generar_JSON = async (IdPedido, 
    IdTipoPedido, IdDocVentaTipo,
    Fecha, IdCliente, NumeroFantasia, NumeroPtoVta, Numero, Factura, CodigoMoneda, Cotizacion,
    ImporteBonificaciones, ImporteRecargos, Concepto, Observaciones, 
    ConEnvio, FechaCompromiso, CodigoCondicionVenta, Abono, AbonoDiaDelMes, AbonoCaduca, AbonoCodigoSubCC, 
    AbonoCodigoCuentaContable, AbonoFechaCaducidad, AbonoUltimaFechaGenerada, CodigoMonedaReferente,
    Autorizado, Bloqueado, Impreso, Preparado, IdUsuarioCreador, IdUsuarioPreparador, CodigoLocacion, 
    IdProveedorDelivery, CodigoOperacionProveedorDelivery, CodigoMesa, CantidadComensales, 
    IdProfesionalMozo, ColeccionDetalles, ColeccionImpuestos, ColeccionProfesionalesACargo) => {
    const NombreFuncion = "function_VEN_Pedido_Generar_JSON";

    try {
        const totalImporteNetoDetalles = ColeccionDetalles.reduce((total, detalle) => total + detalle.ImporteNetoTotal, 0);
        const totalImporteBonificacionesDetalles = ColeccionDetalles.reduce((total, detalle) => total + detalle.ImporteBonificacionesTotal, 0);
        const totalImporteRecargosDetalles = ColeccionDetalles.reduce((total, detalle) => total + detalle.ImporteRecargosTotal, 0);
        const totalImporteSubTotalDetalles = ColeccionDetalles.reduce((total, detalle) => total + detalle.ImporteSubTotalTotal, 0);
        const totalImporteIVADetalles = ColeccionDetalles.reduce((total, detalle) => total + detalle.ImporteIVATotal, 0);
        const totalImporteImpuestosInternosDetalles = ColeccionDetalles.reduce((total, detalle) => total + detalle.ImporteImpuestosInternosTotal, 0);
        const totalImporteTotalDetalles = ColeccionDetalles.reduce((total, detalle) => total + detalle.ImporteTotalTotal, 0);
        const totalImporteTotalPostImpuestos = totalImporteTotalDetalles;

        let CotizacionMonedaReferente = 1;
        let ImporteTotalPostImpuestosMonedaReferente = totalImporteTotalPostImpuestos;

        if (!ImporteBonificaciones) {
            ImporteBonificaciones = 0
        }

        if (!ImporteRecargos) {
            ImporteRecargos = 0
        }

        if (!CodigoMonedaReferente) {
            CodigoMonedaReferente = CodigoMoneda
            CotizacionMonedaReferente = 1
        }
        else {
            const MonedaReferente = await function_ABM_CON_Monedas_Leer(CodigoMonedaReferente)
            CotizacionMonedaReferente = MonedaReferente.data[0].Cotizacion
            ImporteTotalPostImpuestosMonedaReferente = totalImporteTotalPostImpuestos / CotizacionMonedaReferente
        }

        const JSON = {
            IdPedido: IdPedido,
            CodigoCompania: localStorage.getItem("CodigoCompania"),
            CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
            CodigoPlanta: localStorage.getItem("CodigoPlanta"),
            IdTipoPedido: IdTipoPedido,
            Fecha: Fecha,
            IdCliente: IdCliente,
            NumeroFantasia: NumeroFantasia,
            NumeroPtoVta: NumeroPtoVta,
            Numero: Numero,
            Factura: Factura,            
            CodigoMoneda: CodigoMoneda,
            Cotizacion: Cotizacion,
            ImporteNeto: totalImporteNetoDetalles,
            ImporteBonificaciones: ImporteBonificaciones,
            ImporteRecargos: ImporteRecargos,
            ImporteBonificacionesItems: totalImporteBonificacionesDetalles,
            ImporteRecargosItems: totalImporteRecargosDetalles,
            ImporteTotal: totalImporteTotalDetalles,
            ImporteTotalPostImpuestos: totalImporteTotalPostImpuestos,
            ImporteFacturado: 0,
            Concepto: Concepto,
            Observaciones: Observaciones,
            IdEstado: 230,
            ConEnvio: ConEnvio, 
            FechaCompromiso: FechaCompromiso, 
            CodigoCondicionVenta: CodigoCondicionVenta, 
            Abono: Abono, 
            AbonoDiaDelMes: AbonoDiaDelMes, 
            AbonoCaduca: AbonoCaduca, 
            AbonoCodigoSubCC: AbonoCodigoSubCC, 
            AbonoCodigoCuentaContable: AbonoCodigoCuentaContable, 
            AbonoFechaCaducidad: AbonoFechaCaducidad, 
            AbonoUltimaFechaGenerada: AbonoUltimaFechaGenerada, 
            CodigoMonedaReferente: CodigoMonedaReferente, 
            CotizacionMonedaReferente: CotizacionMonedaReferente, 
            ImporteTotalPostImpuestosMonedaReferente: ImporteTotalPostImpuestosMonedaReferente, 
            Autorizado: Autorizado, 
            Bloqueado: Bloqueado, 
            Impreso: Impreso, 
            Preparado: Preparado, 
            IdUsuarioCreador: IdUsuarioCreador, 
            IdUsuarioPreparador: IdUsuarioPreparador, 
            CodigoLocacion: CodigoLocacion, 
            Terminal: localStorage.getItem("Terminal"), 
            IdProveedorDelivery: IdProveedorDelivery, 
            CodigoOperacionProveedorDelivery: CodigoOperacionProveedorDelivery, 
            CodigoMesa: CodigoMesa, 
            CantidadComensales: CantidadComensales, 
            IdProfesionalMozo: IdProfesionalMozo, 
            Detalles: ColeccionDetalles.map(original => ({
                ...original,
                CodigoCompania: localStorage.getItem("CodigoCompania"),
                CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
                CodigoPlanta: localStorage.getItem("CodigoPlanta")
              })),
            Impuestos: ColeccionImpuestos.map(original => ({
                ...original,
                CodigoCompania: localStorage.getItem("CodigoCompania"),
                CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
                CodigoPlanta: localStorage.getItem("CodigoPlanta")
              })),
            ProfesionalesACargo: ColeccionProfesionalesACargo.map(original => ({
                ...original,
                CodigoCompania: localStorage.getItem("CodigoCompania"),
                CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
                CodigoPlanta: localStorage.getItem("CodigoPlanta")
              })),
            IdTipoDocVenta: IdDocVentaTipo
        };

        return JSON;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_VEN_Pedidos_Cabecera_ListarPorCliente = async (FechaDesde, FechaHasta, IdCliente) => {
    const NombreFuncion = "function_VEN_Pedidos_Cabecera_ListarPorCliente"

    try {
        const resulData = await llamadaAPI_GET("VEN_Pedidos_Cabecera/ListarPorCliente/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta + "/" +
            IdCliente);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Pedidos_Cabecera_ListarPorProfesional = async (FechaDesde, FechaHasta, IdProfesional) => {
    const NombreFuncion = "function_VEN_Pedidos_Cabecera_ListarPorProfesional"

    try {
        const resulData = await llamadaAPI_GET("VEN_Pedidos_Cabecera/ListarPorProfesional/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta + "/" +
            IdProfesional);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Pedidos_Cabecera_Eliminar = async (IdPedido) => {
    const NombreFuncion = "function_VEN_Pedidos_Cabecera_Eliminar"

    try {
        const resulData = await llamadaAPI_PUT("VEN_Pedidos_Cabecera/Eliminar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdPedido);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Pedidos_Cabecera_ReportePedido = async (IdPedido, formato) => {
    const NombreFuncion = "function_VEN_Pedidos_Cabecera_ReportePedido";

    try {
        const resulData = await llamadaAPI_GETBinario("VEN_Pedidos_Cabecera/GenerarDocumento/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdPedido);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Pedidos_Cabecera_ReportePedido_EnvioMail = async (IdPedido, toEmail) => {
    const NombreFuncion = "function_VEN_Pedidos_Cabecera_ReportePedido_EnvioMail";

    try {
        const resulData = await llamadaAPI_GET("VEN_Pedidos_Cabecera/EnvioMail/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdPedido + "/" +
            await TratamientoDeParametroParaURI(toEmail));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Pedidos_Cabecera_CancelarPendientesDeRemision = async (IdPedido) => {
    const NombreFuncion = "function_VEN_Pedidos_Cabecera_CancelarPendientesDeRemision"

    try {
        const resulData = await llamadaAPI_GET("VEN_Pedidos_Cabecera/CancelarPendientesDeRemision/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdPedido);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Pedidos_Cabecera_CancelarPendientesDeFacturacion = async (IdPedido) => {
    const NombreFuncion = "function_VEN_Pedidos_Cabecera_CancelarPendientesDeFacturacion"

    try {
        const resulData = await llamadaAPI_GET("VEN_Pedidos_Cabecera/CancelarPendientesDeFacturacion/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdPedido);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Pedidos_Cabecera_ListarClientesSinPedidoPorTiempo = async () => {
    const NombreFuncion = "function_VEN_Pedidos_Cabecera_ListarClientesSinPedidoPorTiempo"

    try {
        const resulData = await llamadaAPI_GET("VEN_Pedidos_Cabecera/ListarClientesSinPedidoPorTiempo/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta"));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};